import React from 'react';

import { INTEGRATION_PAGE_PATH } from 'application/consts';
import IntegrationPageWrapper from 'application/pages/IntegrationPage';
import CleanLayout from 'application/layout/CleanLayout';

import { RouteConfig } from '..';

export const integrationRoutes: RouteConfig[] = [
  {
    element: <CleanLayout />,
    children: [
      {
        path: INTEGRATION_PAGE_PATH,
        element: <IntegrationPageWrapper />,
      },
    ],
  },
];
